import React from 'react';
import { useTranslation } from 'react-i18next';
import { OrderingSelectors, OrderingConstants } from 'polygon-ordering';
import Text from './Text';
import PaymentMethod from './PaymentMethod';
import { PAYMENT_METHOD } from '../libs/polygon-ordering/src/constants/paymentMethod';
import { useAppSelector } from '../app/hooks';

const { getMember, getUnavailableReasonsMemberPoints } = OrderingSelectors;

const PaymentMethodMemberPoints: React.FC = () => {
  const { t } = useTranslation();
  const member = useAppSelector(getMember);
  const unavailableReasonsMemberPoints = useAppSelector(getUnavailableReasonsMemberPoints);

  if (!member) {
    return null;
  }

  const reason = unavailableReasonsMemberPoints[0];

  return (
    <PaymentMethod
      method={PAYMENT_METHOD.MEMBER_POINTS}
      right={
        <Text themeKey="paymentMethodAvailableBalance">{'Available: ' + member.pointsBalance}</Text>
      }
      subtitle={
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
          {reason ? (
            <Text themeKey="paymentMethodUnavailableReason">
              {t(`paymentMethodUnavailableReason.${reason}`)}
            </Text>
          ) : (
            <Text themeKey="paymentMethodUnavailableReason">&nbsp;</Text>
          )}
        </div>
      }
    ></PaymentMethod>
  );
};

export default PaymentMethodMemberPoints;
